import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../messages/general-export-messages';
import style from '../export-records-modal.module.less';

export const AddFieldsMessage = () => {
  return (
    <div className={style['add-fields-message']}>
      <FormattedMessage {...messages.addFieldsMessage} />
    </div>
  );
};
